import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import './caseStudy.css';
import LazyLoad from 'react-lazyload';
import BlurhashImg from '../../@/components/Image/BlurhashImg';
import {WhatGPT3 } from '../../containers'

const CaseStudy = () => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { slug } = useParams();
  const videoRefs = useRef({});
  const [playingVideos, setPlayingVideos] = useState({});

  useEffect(() => {
    const fetchProject = async () => {
      try {
        console.log('Fetching project with slug or ID:', slug);
        if (!slug) {
          throw new Error('Slug or ID is undefined');
        }

        let projectData;

        // First, try to fetch by slug
        const projectRef = collection(db, 'team-members');
        const q = query(projectRef, where('slug', '==', slug));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          projectData = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
        } else {
          // If not found by slug, try to fetch by ID
          const docRef = doc(db, 'team-members', slug);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            projectData = { id: docSnap.id, ...docSnap.data() };
          } else {
            throw new Error('No project found for this slug or ID!');
          }
        }

        console.log('Project data:', projectData);
        setProject(projectData);
      } catch (error) {
        console.error('Error fetching project:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [slug]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(error => console.error('Error playing video:', error));
            setPlayingVideos(prev => ({ ...prev, [video.id]: true }));
          } else {
            video.pause();
            setPlayingVideos(prev => ({ ...prev, [video.id]: false }));
          }
        });
      },
      { threshold: 0.5 }
    );

    Object.values(videoRefs.current).forEach(video => {
      if (video) observer.observe(video);
    });

    return () => {
      Object.values(videoRefs.current).forEach(video => {
        if (video) observer.unobserve(video);
      });
    };
  }, [project]);

  const handlePlayPause = (videoId) => {
    const video = videoRefs.current[videoId];
    if (video) {
      if (playingVideos[videoId]) {
        video.pause();
      } else {
        video.play().catch(error => console.error('Error playing video:', error));
      }
      setPlayingVideos(prev => ({ ...prev, [videoId]: !prev[videoId] }));
    }
  };

  const getFirstTextSection = (article) => {
    if (!article?.sections) return article?.content || '';
    const firstTextSection = article.sections.find(section => section.type === 'text');
    return firstTextSection?.content || article?.content || '';
  };


  // if (loading)
  //   return (
  //     <div className="loading-container">
  //       <div className="spinner"></div>
  //       <p>Loading projects details...</p>
  //     </div>
  //   );
  // if (error)
  //   return (
  //     <div className="error-container">
  //       <div className="error-icon">⚠️</div>
  //       <p>Error: {error}</p>
  //     </div>
  //   );


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
        <p className="ml-4 text-lg">Loading case studies...</p>
      </div>
    );
  }
  


  const renderContent = (content) => {
    if (typeof content === 'string') {
      return content.split(',').map(item => item.trim());
    }
    return Array.isArray(content) ? content : [content];
  };

  const getProjectLink = (relatedProject) => {
    return relatedProject.slug ? `/work/${relatedProject.slug}` : `/work/${relatedProject.id}`;
  };

  return (
    <div className='ulev_details'>
      <div className="ulev__details-title section__padding-case-title">
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%'}}>
          <div className='ulev__details-title-big'>
            <h1 style={{color: '#000000', fontSize: "clamp(28px, 4vw, 38px)"}}><span>{project.title || 'No Title'}</span></h1>
            <h2 style={{color: '#CD3333'}}>{project.subtitle || 'No Subtitle'}</h2>
          </div>
        </div>
      </div>

      {project.coverMedia && (
        <div className='ulev__details-cover-container' style={{ position: 'relative', padding: "0" }}>
          {/* <div className="ulev__details-title-overlay">
            <h1 style={{ color: '#000000' }}><span>{project.title || 'No Title'}</span></h1>
            <h2 style={{ color: '#000' }}>{project.subtitle || 'No Subtitle'}</h2>
          </div> */}
          <div className="single-image-section">
            {project.coverMedia.type === 'video' ? (
              <video
                ref={el => videoRefs.current['cover'] = el}
                id="cover"
                loop
                autoPlay
                muted
                playsInline
                onClick={() => handlePlayPause('cover')}
                style={{ cursor: 'pointer', width: '100%' }}
              >
                <source src={project.coverMedia.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <BlurhashImg src={project.coverMedia.url} placeholderColor="#888" style={{ width: '100%' }} />
            )}
          </div>
        </div>
      )}


      {project.sections && project.sections.length > 0 && project.sections.map((section, index) => (
        <div key={index} className="ulev_morePD " id={`section-${index}`}>
          {section.type === 'text' && (
            <div className="ulev_morePD-contain sectiona__padding">
              <p className='ulev_morePD-other'></p>
              <div className='ulev_morePD-p'>
                <div 
                  dangerouslySetInnerHTML={{ __html: section.content }} 
                  className="ulev_morePD-content"
                  style={{color: "#fff"}}
                />
              </div>
            </div>
          )}
          {section.type === 'image' && section.layout !== 'double' && (
            <div className='ulev__details-images image__padding' style={{padding: "0rem 4.2rem 0rem 4.2rem"}}>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single-image-section">
                  <BlurhashImg src={url} placeholderColor="#888"/>
                </div>
              ))}
            </div>
          )}
          {section.type === 'image_pair' && (
            <div className='ulev__details-image-pair sectionass__padding'>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className='half-image-section'>
                  <BlurhashImg src={url} placeholderColor="#888"/>
                </div>
              ))}
            </div>
          )}
          {section.type === 'video' && section.layout === 'double' && (
            <div className='ulev__details-images section__padding ulev__details-images-double'>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single-image-section">
                  <video
                    ref={el => videoRefs.current[`video-${index}-${idx}`] = el}
                    id={`video-${index}-${idx}`}
                    loop
                    autoPlay
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
          {section.type === 'video' && section.layout !== 'double' && (
            <div className='ulev__details-images ' style={{padding: "4rem 4rem 4rem 4rem"}}>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className="single-image-section">
                  <video
                    ref={el => videoRefs.current[`video-${index}-${idx}`] = el}
                    id={`video-${index}-${idx}`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
          {section.type === 'video_pair' && (
            <div className='ulev__details-video-pair sectiona__padding-vid'>
              {renderContent(section.content).map((url, idx) => (
                <div key={idx} className='half-video-section'>
                  <video
                    ref={el => videoRefs.current[`video-pair-${index}-${idx}`] = el}
                    id={`video-pair-${index}-${idx}`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onClick={() => handlePlayPause(`video-pair-${index}-${idx}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      {project.relatedProjects && project.relatedProjects.length > 0 && (
        <div className="section__padding-case">
          <h2 style={{
            fontFamily: "Poppins-SemiBold", 
            color: "#CD3333", 
            fontSize: "clamp(24px, 4vw, 28px)", 
            fontWeight: "600",
            paddingBottom: "20px"
          }}>
            More Stories
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {project.relatedProjects.map((relatedProject, index) => (
              <Link 
                key={index} 
                to={`/work/${relatedProject.slug}`} 
                className="mb-8 cursor-pointer duration-300 relative group"
              >
                <div className="relative h-[300px] w-full overflow-hidden" style={{height: "600px"}}>
                  <BlurhashImg
                    src={relatedProject.coverImage}
                    alt={relatedProject.title}
                    className="w-full h-full object-cover responsive blur_load"
                    loading="lazy"
                    placeholderColor="#888"
                    onError={(e) => {
                      console.error('Error loading image:', relatedProject.coverImage);
                      e.target.src = '/fallback-image.jpg';
                    }}
                  />
                  <div 
                    className="absolute inset-0 bg-black bg-opacity-60 group-hover:bg-opacity-40 transition-all duration-300"
                  />
                  <div 
                    className="absolute bottom-0 left-0 right-0 py-14 px-8 z-10 text-white"
                    style={{
                      fontFamily: "Poppins-Light"
                    }}
                  >
                    <p 
                      className="text-[#CD3333] mb-2"
                      style={{
                        fontFamily: "Poppins-Regular",
                        fontSize: "16px"
                      }}
                    >
                      {relatedProject.category || 'Project'}
                    </p>
                    <h3 
                      className="text-white mb-2 group-hover:text-opacity-100 text-opacity-90 transition-all duration-300"
                      style={{
                        fontFamily: "Poppins-SemiBold",
                        fontSize: "26px",
                        fontWeight: "600",
                        lineHeight: "1.2"
                      }}
                    >
                      {relatedProject.title}
                    </h3>
                    <p 
                      className="text-white text-opacity-80 group-hover:text-opacity-100 transition-all duration-300"
                      style={{
                        fontFamily: "Poppins-Light", 
                        lineHeight: "1.3", 
                        fontSize: '14px'
                      }}
                    >
                      {(() => {
                        const content = getFirstTextSection(relatedProject);
                        if (!content) return 'No content available';
                        return content.length > 250 ? content.slice(0, 250) + '...' : content;
                      })()}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
      <WhatGPT3 />
    </div>
  );
};

export default CaseStudy;
